import { EventsTable } from "fleet/view/event/table";
import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";
import { NavLoader } from "ui/loader";

class DeviceEvents extends React.Component {
  static get propTypes() {
    return {
      applications: PropTypes.object.isRequired,
      device: PropTypes.object,
      devices: PropTypes.object.isRequired,
      eventsV3: PropTypes.array.isRequired,
      fetchV3Events: PropTypes.func.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      unloadV3Events: PropTypes.func.isRequired,
    };
  }

  componentWillUnmount() {
    this.props.unloadV3Events();
  }

  render() {
    const {
      applications,
      device,
      devices,
      eventsV3,
      fetchV3Events,
      storesLoaded,
    } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    if (!device) {
      return <Redirect to="/404" />;
    }

    return (
      <EventsTable
        events={eventsV3}
        applications={applications}
        device={device}
        devices={devices}
        fetchMethod={fetchV3Events}
      />
    );
  }
}

export { DeviceEvents };
